var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurious(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.00464C17.5228 2.00464 22 6.48179 22 12.0046C22 17.5275 17.5228 22.0046 12 22.0046C6.47715 22.0046 2 17.5275 2 12.0046C2 6.48179 6.47715 2.00464 12 2.00464ZM12 13C10.7574 13 9.75 14.0074 9.75 15.25C9.75 16.4927 10.7574 17.5 12 17.5C13.2426 17.5 14.25 16.4927 14.25 15.25C14.25 14.0074 13.2426 13 12 13ZM9.00045 8.75117C8.31048 8.75117 7.75116 9.3105 7.75116 10.0005C7.75116 10.6904 8.31048 11.2498 9.00045 11.2498C9.69041 11.2498 10.2497 10.6904 10.2497 10.0005C10.2497 9.3105 9.69041 8.75117 9.00045 8.75117ZM15.0004 8.75117C14.3105 8.75117 13.7512 9.3105 13.7512 10.0005C13.7512 10.6904 14.3105 11.2498 15.0004 11.2498C15.6904 11.2498 16.2497 10.6904 16.2497 10.0005C16.2497 9.3105 15.6904 8.75117 15.0004 8.75117Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurious);
export default __webpack_public_path__ + "static/media/curious.17238e4e.svg";
export { ForwardRef as ReactComponent };